const metadataSlice = {
    navButtons: {
        builder: true,
        preset: true
    }
}

export default metadataSlice
export { metadataSlice }
